import {
  isAtwOnePagesPreviewHost,
  isAtwOnePublicHost,
  PROD_ONE_HOST,
} from "@/lib/atwOneHost";
import { atwAuthSigninUrl } from "@/lib/atwAuthHost";
import { atwOneAppOrigin } from "@/lib/atwOneHost";

/**
 * API origin for credentialed fetches.
 * - `one.atw.net` on Pages: same-origin `/api` worker proxy.
 * - `atw-one.pages.dev`: cross-origin to `one.atw.net` so `.atw.net` session cookies attach (WorkSuite peel pattern).
 */
export function apiOrigin(): string {
  const fromEnv = import.meta.env.VITE_API_BASE?.trim();
  if (fromEnv) return fromEnv.replace(/\/$/, "");
  if (typeof window !== "undefined") {
    const h = window.location.hostname.toLowerCase();
    if (isAtwOnePagesPreviewHost(h) || (h.endsWith(".pages.dev") && h.includes("atw-one"))) {
      return `https://${PROD_ONE_HOST}`;
    }
    if (isAtwOnePublicHost(h)) {
      return window.location.origin.replace(/\/$/, "");
    }
  }
  return `https://${PROD_ONE_HOST}`;
}

export function apiFetchInit(): RequestInit {
  return { credentials: "include" };
}

export function authSignInUrl(callbackPath: string): string {
  const path = callbackPath.startsWith("/") ? callbackPath : `/${callbackPath}`;
  const callback = `${atwOneAppOrigin()}${path}`;
  return atwAuthSigninUrl(callback);
}

/** Full-page redirect to the auth hub sign-in (once per page load). */
export function redirectToSignIn(callbackPath?: string): void {
  if (typeof window === "undefined") return;
  const path =
    callbackPath ??
    `${window.location.pathname}${window.location.search}${window.location.hash}`;
  window.location.assign(authSignInUrl(path));
}

export function apiUrl(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${apiOrigin()}${p}`;
}
